<template>
  <div class="px-8 py-1">
    <v-container grid-list-xl fluid class="px-0">
      <v-layout row wrap class="pr-3 mb-2">
        <v-flex xs8 class="pb-0">
          <h3 class="darkblue--text fs-16 lh-16 font-weight-700">PO REPORT</h3>
          <v-breadcrumbs
            class="
              px-0
              subtitle-2
              mt-2
              py-0
              breadcrumbs-items
              custom-breadcrumbs
            "
            :items="breadcrumbs"
          ></v-breadcrumbs>
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          class="mt-3 mr-3"
          dark
          @click="downloadFile()"
          v-if="isLoggedInAsBO"
        >
          <!-- @click="downloadFile()" -->
          <v-icon size="10px">mdi-download</v-icon> Download
        </v-btn>
        <advance-filter
          title="PO Monitoring"
          @getFiltered="getFiltered"
          class="pt-1"
          v-else
        />
        <v-flex xs2 class="text-center pb-0 pt-3 pl-0">
          <date-picker
            v-model="yearBo"
            type="year"
            placeholder="Filter"
            format="YYYY"
            class="dashSearch filterSearch"
          />
        </v-flex>
      </v-layout>
      <v-flex
        xs12
        class="pa-0 grey--text font-weight-500 fs-12 lh-16 ml-3 pt-1"
        style="margin-top: -12px"
      >
        <v-row>
          <v-expansion-panels flat class="filterby-info">
            <v-expansion-panel>
              <v-expansion-panel-header
                class="grey--text fs-13 px-0 pt-0 pb-1 secondary"
                height="100px"
              >
                Filter By Information
              </v-expansion-panel-header>
              <v-expansion-panel-content class="grey--text secondary">
                <ul v-if="filterBy.length > 0">
                  <li
                    v-for="(filter, indexFilter) in filterBy"
                    :key="'filter' + indexFilter"
                    class="text-left"
                  >
                    {{ yearInfo }}
                    <template v-for="(detail, indexDetail) in filter">
                      {{ ' / ' }}
                      <span :key="'indexDetail-' + indexDetail">
                        {{ detail.map(e => e.name).join(' / ') }}
                      </span>
                    </template>
                  </li>
                </ul>
                <ul v-else>
                  <li>{{ yearInfo }}</li>
                </ul>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-row>
      </v-flex>
    </v-container>

    <v-layout class="table-po">
      <v-flex xs12>
        <v-card class="rounded-12 elevation-card pb-4">
          <v-card-title>
            <v-flex xs9 class="font-weight-500"> PO REPORT </v-flex>
            <v-flex xs3 class="text-right">
              <v-icon class="mr-4"></v-icon>
              <v-icon id="refresh" @click="getData(yearBo)"> refresh </v-icon>
            </v-flex>
          </v-card-title>
          <v-row class="px-2">
            <v-flex xs4 class="mb-5 px-5">
              <v-text-field
                id="search"
                v-model="search"
                append-icon="search"
                label="Search by IO Number or PO Number"
                single-line
                hide-details
                @keyup="searchPOAll()"
              ></v-text-field>
            </v-flex>
            <v-spacer />
            <v-col cols="auto" class="mt-2">
              <v-menu :close-on-content-click="false">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    id="btn-column"
                    class="primary--text pb-0 mr-3"
                    depressed
                    color="lightblue"
                    v-bind="attrs"
                    v-on="on"
                  >
                    Select Column
                  </v-btn>
                </template>
                <v-list-item-group
                  v-model="columnActive"
                  multiple
                  class="white"
                >
                  <div
                    class="px-4 py-2"
                    @click="selectAllColumn()"
                    style="cursor: pointer"
                  >
                    <v-row>
                      <v-flex
                        xs2
                        class="ml-4"
                        style="max-width: 37px !important"
                      >
                        <v-icon v-if="selectAll" color="primary accent-4">
                          check_box
                        </v-icon>
                        <v-icon color="primary accent-4" v-else>
                          check_box_outline_blank
                        </v-icon>
                      </v-flex>
                      <v-flex xs8 class="pt-1">
                        <v-list-item-title class="text-left">
                          Select All
                        </v-list-item-title>
                      </v-flex>
                    </v-row>
                  </div>
                  <v-perfect-scroll class="select-column-scroll">
                    <template v-for="(item, i) in poColumn">
                      <v-divider v-if="!item" :key="'divider' + i"></v-divider>

                      <v-list-item
                        v-else
                        :key="'item' + i"
                        :value="item.text"
                        class="text-left"
                        style="max-height: 48px !important"
                        active-class="primary--text text--accent-4"
                      >
                        <template v-slot:default="{ active }">
                          <v-list-item-content
                            style="max-width: 20px !important"
                          >
                          </v-list-item-content>

                          <v-list-item-action style="width: 100%">
                            <v-flex xs12>
                              <v-row>
                                <v-flex xs2 style="padding-top: 3.5px">
                                  <v-icon
                                    color="primary accent-4"
                                    v-if="active"
                                  >
                                    check_box
                                  </v-icon>
                                  <v-icon v-else color="primary accent-4">
                                    check_box_outline_blank
                                  </v-icon>
                                </v-flex>
                                <v-flex xs8 class="pt-1">
                                  <v-list-item-title
                                    class="text-left"
                                    v-text="item.text"
                                  >
                                  </v-list-item-title>
                                </v-flex>
                              </v-row>
                            </v-flex>
                          </v-list-item-action>
                        </template>
                      </v-list-item>
                    </template>
                  </v-perfect-scroll>
                </v-list-item-group>
              </v-menu>
            </v-col>
          </v-row>
          <v-data-table
            class="px-4 mt-1 nav-table po-monitoring-table"
            :items="items"
            :page.sync="page"
            @page-count="pageCount = $event"
            :options.sync="options"
            :server-items-length="totalItems"
            :footer-props="{
              itemsPerPageOptions: [10, 25, 50, 100]
            }"
            hide-default-footer
          >
            <template v-slot:header>
              <thead>
                <tr style="width: 100%">
                  <th
                    class="sticky-header1"
                    v-if="columnActive.includes('IO Number')"
                  >
                    IO Number
                    <filter-column
                      field="io_number"
                      :indexItem="0"
                      @searchColumn="searchCln"
                      @sortBy="sortBy"
                      :listFilter="[]"
                      @checkColumn="checkColumn"
                      :year="yearBo"
                      :paramFiltered="paramFiltered"
                    />
                  </th>
                  <th v-if="columnActive.includes('IO Description')">
                    IO Description
                    <filter-column
                      field="io_desc"
                      :indexItem="1"
                      @searchColumn="searchCln"
                      @sortBy="sortBy"
                      :listFilter="[]"
                      @checkColumn="checkColumn"
                      :year="yearBo"
                      :paramFiltered="paramFiltered"
                    />
                  </th>
                  <th v-if="columnActive.includes('Budget Owner')">
                    Budget Owner
                    <filter-column
                      field="budget_owner"
                      :indexItem="2"
                      @searchColumn="searchCln"
                      @sortBy="sortBy"
                      :listFilter="[]"
                      @checkColumn="checkColumn"
                      :year="yearBo"
                      :paramFiltered="paramFiltered"
                    />
                  </th>
                  <th v-if="columnActive.includes('PO Number')">
                    PO Number
                    <filter-column
                      field="po_number"
                      :indexItem="3"
                      @searchColumn="searchCln"
                      @sortBy="sortBy"
                      :listFilter="[]"
                      @checkColumn="checkColumn"
                      :year="yearBo"
                      :paramFiltered="paramFiltered"
                    />
                  </th>
                  <th v-if="columnActive.includes('PO Date')">
                    PO Date
                    <filter-column
                      field="po_date"
                      :indexItem="4"
                      @searchColumn="searchCln"
                      @sortBy="sortBy"
                      :listFilter="[]"
                      @checkColumn="checkColumn"
                      :year="yearBo"
                      :paramFiltered="paramFiltered"
                    />
                  </th>
                  <th v-if="columnActive.includes('Delivery Date')">
                    Delivery Date
                    <filter-column
                      field="delivery_date"
                      :indexItem="5"
                      @searchColumn="searchCln"
                      @sortBy="sortBy"
                      :listFilter="[]"
                      @checkColumn="checkColumn"
                      :year="yearBo"
                      :paramFiltered="paramFiltered"
                    />
                  </th>
                  <th v-if="columnActive.includes('Vendor Name')">
                    Vendor Name
                    <filter-column
                      field="vendor_name"
                      :indexItem="6"
                      @searchColumn="searchCln"
                      @sortBy="sortBy"
                      :listFilter="[]"
                      @checkColumn="checkColumn"
                      :year="yearBo"
                      :paramFiltered="paramFiltered"
                    />
                  </th>
                  <th v-if="columnActive.includes('PO Line Item Text')">
                    PO Line Item Text
                    <filter-column
                      field="po_item"
                      :indexItem="7"
                      @searchColumn="searchCln"
                      @sortBy="sortBy"
                      :listFilter="[]"
                      @checkColumn="checkColumn"
                      :year="yearBo"
                      :paramFiltered="paramFiltered"
                    />
                  </th>
                  <th v-if="columnActive.includes('Release Indicator')">
                    Release Indicator
                    <filter-column
                      field="release_desc"
                      :indexItem="8"
                      @searchColumn="searchCln"
                      @sortBy="sortBy"
                      :listFilter="[]"
                      @checkColumn="checkColumn"
                      :year="yearBo"
                      :paramFiltered="paramFiltered"
                    />
                  </th>
                  <th v-if="columnActive.includes('PO Release Status')">
                    PO Release Status
                    <filter-column
                      field="po_release_status"
                      :indexItem="9"
                      @sortBy="sortBy"
                      :listFilter="[]"
                      @checkColumn="checkColumn"
                      :year="yearBo"
                      :paramFiltered="paramFiltered"
                    />
                  </th>
                  <th v-if="columnActive.includes('Delivery Status')">
                    Delivery Status
                    <filter-column
                      field="is_completed"
                      :indexItem="10"
                      @searchColumn="searchCln"
                      @sortBy="sortBy"
                      :listFilter="[]"
                      @checkColumn="checkColumn"
                      :year="yearBo"
                      :paramFiltered="paramFiltered"
                    />
                  </th>
                  <th v-if="columnActive.includes('PO Currency')">
                    PO Currency
                    <filter-column
                      field="currency"
                      :indexItem="11"
                      @searchColumn="searchCln"
                      @sortBy="sortBy"
                      :listFilter="[]"
                      @checkColumn="checkColumn"
                      :year="yearBo"
                      :paramFiltered="paramFiltered"
                    />
                  </th>
                  <th v-if="columnActive.includes('Exchange Rate')">
                    Exchange Rate
                    <filter-column
                      field="exchange_rate"
                      :indexItem="12"
                      @searchColumn="searchCln"
                      @sortBy="sortBy"
                      :listFilter="[]"
                      @checkColumn="checkColumn"
                      :year="yearBo"
                      :paramFiltered="paramFiltered"
                    />
                  </th>
                  <th v-if="columnActive.includes('PO Amount (Doc Currency)')">
                    PO Amount (Doc Currency)
                    <filter-column
                      field="amount"
                      :indexItem="13"
                      @searchColumn="searchCln"
                      @sortBy="sortBy"
                      :listFilter="[]"
                      @checkColumn="checkColumn"
                      :columnType="true"
                      :year="yearBo"
                      :paramFiltered="paramFiltered"
                    />
                  </th>
                  <th v-if="columnActive.includes('PO Amount (IDR)')">
                    PO Amount (IDR)
                    <filter-column
                      field="amount_idr"
                      :indexItem="14"
                      @searchColumn="searchCln"
                      @sortBy="sortBy"
                      :listFilter="[]"
                      @checkColumn="checkColumn"
                      :columnType="true"
                      :year="yearBo"
                      :paramFiltered="paramFiltered"
                    />
                  </th>
                  <th v-if="columnActive.includes('Amount Complete (IDR)')">
                    Amount Complete (IDR)
                    <filter-column
                      field="amount_complete"
                      :indexItem="15"
                      @searchColumn="searchCln"
                      @sortBy="sortBy"
                      :listFilter="[]"
                      @checkColumn="checkColumn"
                      :columnType="true"
                      :year="yearBo"
                      :paramFiltered="paramFiltered"
                    />
                  </th>
                  <th
                    v-if="columnActive.includes('PO Amount (Local Currency)')"
                  >
                    PO Amount (Local Currency)
                    <filter-column
                      field="amount_local_currency"
                      :indexItem="16"
                      @searchColumn="searchCln"
                      @sortBy="sortBy"
                      :listFilter="[]"
                      @checkColumn="checkColumn"
                      :columnType="true"
                      :year="yearBo"
                      :paramFiltered="paramFiltered"
                    />
                  </th>
                  <th v-if="columnActive.includes('GR Amount (IDR)')">
                    GR Amount (IDR)
                    <filter-column
                      field="gr"
                      :indexItem="17"
                      @searchColumn="searchCln"
                      @sortBy="sortBy"
                      :listFilter="[]"
                      @checkColumn="checkColumn"
                      :columnType="true"
                      :year="yearBo"
                      :paramFiltered="paramFiltered"
                    />
                  </th>
                  <th v-if="columnActive.includes('IR Amount (IDR)')">
                    IR Amount (IDR)
                    <filter-column
                      field="ir"
                      :indexItem="18"
                      @searchColumn="searchCln"
                      @sortBy="sortBy"
                      :listFilter="[]"
                      @checkColumn="checkColumn"
                      :columnType="true"
                      :year="yearBo"
                      :paramFiltered="paramFiltered"
                    />
                  </th>
                  <th v-if="columnActive.includes('Remaining PO')">
                    Remaining PO
                    <filter-column
                      field="remaining_po"
                      :indexItem="19"
                      @searchColumn="searchCln"
                      @sortBy="sortBy"
                      :listFilter="[]"
                      @checkColumn="checkColumn"
                      :columnType="true"
                      :year="yearBo"
                      :paramFiltered="paramFiltered"
                    />
                  </th>
                  <th
                    v-if="
                      hasPermission('update_po_manual', 'update') &&
                        columnActive.includes('Action')
                    "
                  >
                    Action
                  </th>
                </tr>
              </thead>
            </template>
            <template v-slot:body="{ items }">
              <tbody v-if="items.length > 0">
                <tr v-for="(item, index) in items" :key="index">
                  <td
                    class="sticky-body1"
                    v-if="columnActive.includes('IO Number')"
                  >
                    {{ item.io_number ? item.io_number : '-' }}
                  </td>
                  <td v-if="columnActive.includes('IO Description')">
                    {{ item.io_desc ? item.io_desc : '-' }}
                  </td>
                  <td v-if="columnActive.includes('Budget Owner')">
                    {{ item.budget_owner || '-' }}
                  </td>
                  <td v-if="columnActive.includes('PO Number')">
                    {{ item.po_number ? item.po_number : '-' }}
                  </td>
                  <td v-if="columnActive.includes('PO Date')">
                    {{ formattedDate2(item.po_date) || '-' }}
                  </td>
                  <td v-if="columnActive.includes('Delivery Date')">
                    {{ formattedDate2(item.delivery_date) || '-' }}
                  </td>
                  <td v-if="columnActive.includes('Vendor Name')">
                    {{ item.vendor_name || '-' }}
                  </td>
                  <td v-if="columnActive.includes('PO Line Item Text')">
                    {{ item.po_item ? item.po_item : '-' }}
                  </td>
                  <td v-if="columnActive.includes('Release Indicator')">
                    {{ item.release_desc || '-' }}
                  </td>
                  <td v-if="columnActive.includes('PO Release Status')">
                    {{ item.po_release_status || '-' }}
                  </td>
                  <td v-if="columnActive.includes('Delivery Status')">
                    {{ item.is_completed ? 'Completed' : '-' }}
                  </td>
                  <td v-if="columnActive.includes('PO Currency')">
                    {{ item.currency || '-' }}
                  </td>
                  <td v-if="columnActive.includes('Exchange Rate')">
                    {{ idr(item.exchange_rate) || '-' }}
                  </td>
                  <td
                    v-if="columnActive.includes('PO Amount (Doc Currency)')"
                    class="text-right"
                  >
                    {{ idr(item.amount) }}
                  </td>
                  <td
                    class="text-right"
                    v-if="columnActive.includes('PO Amount (IDR)')"
                  >
                    {{ idr(item.amount_idr) }}
                  </td>
                  <td
                    class="text-right"
                    v-if="columnActive.includes('Amount Complete (IDR)')"
                  >
                    {{ idr(item.amount_complete) }}
                  </td>
                  <td
                    class="text-right"
                    v-if="columnActive.includes('PO Amount (Local Currency)')"
                  >
                    {{
                      item.amount_local_currency
                        ? idr(item.amount_local_currency)
                        : '-'
                    }}
                  </td>
                  <td
                    class="text-right"
                    v-if="columnActive.includes('GR Amount (IDR)')"
                  >
                    {{ idr(item.gr) }}
                  </td>
                  <td
                    class="text-right"
                    v-if="columnActive.includes('IR Amount (IDR)')"
                  >
                    {{ idr(item.ir) }}
                  </td>
                  <td
                    class="text-right"
                    v-if="columnActive.includes('Remaining PO')"
                  >
                    {{ item.remaining_po ? idr(item.remaining_po) : '-' }}
                  </td>
                  <td
                    v-if="
                      hasPermission('update_po_manual', 'update') &&
                        columnActive.includes('Action')
                    "
                    class="text-center"
                  >
                    <v-btn
                      x-small
                      class="white--text"
                      block
                      :color="item.is_completed ? 'primary' : 'menuActive'"
                      @click="completePO(item)"
                    >
                      {{ item.is_completed ? 'Uncomplete' : 'Complete' }}
                    </v-btn>
                  </td>
                </tr>
                <!-- <tr class="bgTotal">
                  <td
                    class="font-weight-bold text-right sticky-body1 bgTotal"
                    style="border-right: 1px solid rgba(0, 0, 0, 0.12)!important; border-bottom: 1px solid rgba(0, 0, 0, 0.12)!important;"
                  >
                    TOTAL
                  </td>
                  <td colspan="12" class="font-weight-bold text-right"></td>
                  <td class="text-right font-weight-bold">
                    {{ totalAmountFor('amount') }}
                  </td>
                  <td class="text-right font-weight-bold">
                    {{ totalAmountFor('amount_idr') }}
                  </td>
                  <td class="text-right font-weight-bold">
                    {{ totalAmountFor('amount_complete') }}
                  </td>
                  <td class="text-right font-weight-bold">
                    {{ totalAmountFor('amount_local_currency') }}
                  </td>
                  <td class="text-right font-weight-bold">
                    {{ totalAmountFor('gr') }}
                  </td>
                  <td class="text-right font-weight-bold">
                    {{ totalAmountFor('ir') }}
                  </td>
                  <td class="text-right font-weight-bold">
                    {{ totalAmountFor('remaining_po') }}
                  </td>
                  <td></td>
                </tr> -->
                <tr
                  class="bgTotal"
                  v-if="
                    amountTotal.pagination.current_page ===
                      amountTotal.pagination.last_page
                  "
                >
                  <!-- <td
                    class="font-weight-bold text-right sticky-body1 bgTotal"
                    style="border-right: 1px solid rgba(0, 0, 0, 0.12)!important; border-bottom: 1px solid rgba(0, 0, 0, 0.12)!important;"
                  >
                    GRAND TOTAL
                  </td>
                  <td colspan="12" class="font-weight-bold text-right"></td> -->
                  <td
                    v-if="columnActive.includes('IO Number')"
                    class="font-weight-bold text-right sticky-body1 bgTotal"
                    style="
                      border-right: 1px solid rgba(0, 0, 0, 0.12) !important;
                      border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
                    "
                  >
                    GRAND TOTAL
                  </td>
                  <td
                    v-if="columnActive.includes('IO Description')"
                    class="border-x-0"
                  ></td>
                  <td
                    v-if="columnActive.includes('Budget Owner')"
                    class="border-x-0"
                  ></td>
                  <td
                    v-if="columnActive.includes('PO Number')"
                    class="border-x-0"
                  ></td>
                  <td
                    v-if="columnActive.includes('PO Date')"
                    class="border-x-0"
                  ></td>
                  <td
                    v-if="columnActive.includes('Delivery Date')"
                    class="border-x-0"
                  ></td>
                  <td
                    v-if="columnActive.includes('Vendor Name')"
                    class="border-x-0"
                  ></td>
                  <td
                    v-if="columnActive.includes('PO Line Item Text')"
                    class="border-x-0"
                  ></td>
                  <td
                    v-if="columnActive.includes('Release Indicator')"
                    class="border-x-0"
                  ></td>
                  <td
                    v-if="columnActive.includes('PO Release Status')"
                    class="border-x-0"
                  ></td>
                  <td
                    v-if="columnActive.includes('Delivery Status')"
                    class="border-x-0"
                  ></td>
                  <td
                    v-if="columnActive.includes('PO Currency')"
                    class="border-x-0"
                  ></td>
                  <td
                    v-if="columnActive.includes('Exchange Rate')"
                    class="border-x-0"
                  ></td>
                  <td
                    class="text-right font-weight-bold"
                    v-if="columnActive.includes('PO Amount (Doc Currency)')"
                  >
                    {{ idr(amountTotal.amount) }}
                  </td>
                  <td
                    class="text-right font-weight-bold"
                    v-if="columnActive.includes('PO Amount (IDR)')"
                  >
                    {{ idr(amountTotal.amount_idr) }}
                  </td>
                  <td
                    class="text-right font-weight-bold"
                    v-if="columnActive.includes('Amount Complete (IDR)')"
                  >
                    {{ idr(amountTotal.amount_complete) }}
                  </td>
                  <td
                    class="text-right font-weight-bold"
                    v-if="columnActive.includes('PO Amount (Local Currency)')"
                  >
                    {{ idr(amountTotal.amount_local_currency) }}
                  </td>
                  <td
                    class="text-right font-weight-bold"
                    v-if="columnActive.includes('GR Amount (IDR)')"
                  >
                    {{ idr(amountTotal.gr) }}
                  </td>
                  <td
                    class="text-right font-weight-bold"
                    v-if="columnActive.includes('IR Amount (IDR)')"
                  >
                    {{ idr(amountTotal.ir) }}
                  </td>
                  <td
                    class="text-right font-weight-bold"
                    v-if="columnActive.includes('Remaining PO')"
                  >
                    {{ idr(amountTotal.remaining_po) }}
                  </td>
                  <td
                    v-if="
                      hasPermission('update_po_manual', 'update') &&
                        columnActive.includes('Action')
                    "
                  ></td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td :colspan="columnActive.length" class="text-center">
                    No data displayed
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
          <v-row no-gutters justify="end">
            <v-col cols="2" class="fs-14 align-self-center px-5 mt-5">
              Total Data: {{ totalItems }}
            </v-col>
            <v-col class="pt-5 text-center fs-14">
              <v-pagination
                v-model="page"
                :length="pageCount"
                :total-visible="10"
                class="mx-4 fs-12 mb-3"
              >
              </v-pagination>
            </v-col>
            <v-col cols="2" class="fs-12 text-right align-self-center mt-2">
              <span>Rows Per Page:</span>
            </v-col>
            <v-col class="px-4 mt-3" cols="1">
              <v-select
                :items="[10, 25, 50, 100]"
                dense
                :value="options.itemsPerPage"
                @input="options.itemsPerPage = parseInt($event)"
              ></v-select>
            </v-col>
          </v-row>
        </v-card>
      </v-flex>
    </v-layout>

    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </div>
</template>

<script>
import ProgressDialog from '../../../components/progress_dialog';
import ACLMixin from '../../../mixins/ACLMixin';
// import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import Swal from 'sweetalert2';
import moment from 'moment';
// import advanceFilter from '../../../components/advanceFilter/selectFilter';
import advanceFilter from '@/components/advanceFilter/DynamicFilter';
import LoginAsMixin from '@/mixins/LoginAsMixin';
import filterColumn from '@/components/filterColumn/monitoring';

export default {
  components: {
    'progress-dialog': ProgressDialog,
    'advance-filter': advanceFilter,
    'filter-column': filterColumn
    // VuePerfectScrollbar
  },
  mixins: [ACLMixin, LoginAsMixin],
  props: ['yearIo', 'io'],
  data() {
    return {
      columnActive: [],
      selectAll: true,
      loading: true,
      progressDialogLoading: true,
      items: [],
      descending: true,
      sort: '',
      totalItems: 0,
      page: 1,
      pageCount: 0,
      options: {
        itemsPerPage: 10
      },
      breadcrumbs: [
        {
          text: 'PO & NON PO MONITORING',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: 'PO REPORT',
          disabled: true,
          href: 'breadcrumbs_link_1'
        }
      ],
      poColumn: [
        {
          text: 'IO Number',
          value: 'io_number',
          sortable: false
        },
        {
          text: 'IO Description',
          value: 'io_desc',
          sortable: false
        },
        {
          text: 'Budget Owner',
          value: 'budget_owner',
          sortable: false
        },
        {
          text: 'PO Number',
          value: 'po_number',
          sortable: false
        },
        {
          text: 'PO Date',
          value: 'poHeader.po_date',
          sortable: false
        },
        {
          text: 'Delivery Date',
          value: 'delivery_date',
          sortable: false
        },
        {
          text: 'Vendor Name',
          value: 'poHeader.vendor.name',
          sortable: false
        },
        {
          text: 'PO Line Item Text',
          value: 'po_item',
          sortable: false
        },
        {
          text: 'Release Indicator',
          value: 'poHeader.release_desc',
          sortable: false
        },
        {
          text: 'PO Release Status',
          value: 'poHeader.po_release_status',
          sortable: false
        },
        {
          text: 'Delivery Status',
          value: 'poHeader.is_completed',
          sortable: false
        },
        {
          text: 'PO Currency',
          value: 'poHeader.currency',
          sortable: false
        },
        {
          text: 'Exchange Rate',
          value: 'poHeader.exchange_rate',
          sortable: false
        },
        {
          text: 'PO Amount (Doc Currency)',
          value: 'amount',
          sortable: false
        },
        {
          text: 'PO Amount (IDR)',
          value: 'amount_idr',
          sortable: false
        },
        {
          text: 'Amount Complete (IDR)',
          value: 'gr',
          sortable: false
        },
        {
          text: 'PO Amount (Local Currency)',
          value: 'po_local',
          sortable: false
        },
        {
          text: 'GR Amount (IDR)',
          value: 'gr',
          sortable: false
        },
        {
          text: 'IR Amount (IDR)',
          value: 'ir',
          sortable: false
        },
        {
          text: 'Remaining PO',
          value: 'remaining_po',
          sortable: false
        },
        {
          text: 'Action',
          value: 'action',
          sortable: false
        }
      ],
      scrollSettings: {
        maxScrollbarLength: 260
      },
      panel: [],
      // year: new Date(),
      yearBo: new Date(),
      showYear: moment(new Date()).format('YYYY'),
      filters: [],
      filter: '',
      isDisabledHouse: false,
      isDisabledDept: false,
      isDisabledBo: false,
      showFilterDialog: false,
      divisionFil: [],
      isDivision: true,
      houseFil: [],
      isHouse: true,
      deptFil: [],
      isDept: true,
      boFil: [],
      isBo: true,
      divisionList: [],
      houseList: [],
      deptList: [],
      boList: [],
      userLevel: [],
      baseUrl: process.env.VUE_APP_BASE_URL,
      isSearch: false,
      search: '',
      amountTotal: {},
      sortColumn: [],
      divId: [],
      groupId: [],
      boId: [],
      filterBy: [],
      searchColumn: [],
      searchChecked: [],
      paramFiltered: [
        {
          divisionIds: [],
          houseIds: [],
          groupIds: [],
          budgetOwnerIds: []
        }
      ]
    };
  },
  async mounted() {
    let path = this.$route.fullPath;
    let page = path.split('/').join('');
    if (page.includes('search')) {
      this.yearBo = new Date(this.yearIo, 1, 1);
      this.search = this.io;
    }
    await this.getData(this.yearBo);
    this.columnActive = this.poColumn.map(column => {
      return column.text;
    });
  },
  computed: {
    yearInfo() {
      return moment(this.yearBo).format('YYYY');
    }
  },
  watch: {
    yearBo(value) {
      this.getData(value);
    },
    'options.page'() {
      this.getData(this.yearBo);
    },
    'options.itemsPerPage'() {
      this.getData(this.yearBo);
    },
    columnActive(val) {
      if (val.length !== this.poColumn.length) {
        this.selectAll = false;
      } else {
        this.selectAll = true;
      }
    },
    poColumn: {
      handler(newVal) {
        this.poColumn = newVal;
      }
    }
  },
  methods: {
    selectAllColumn() {
      if (this.selectAll) {
        this.selectAll = false;
        this.columnActive = [];
      } else {
        this.selectAll = true;
        this.columnActive = this.poColumn.map(column => {
          return column.text;
        });
      }
    },
    getFiltered(val) {
      this.filterBy = val.info;
      this.paramFiltered = val.param;
      if (val.type === 'download') {
        this.downloadFile();
      } else {
        this.getData(this.yearBo);
      }
    },
    searchCln(obj) {
      this.searchColumn = [];
      this.searchColumn[obj.index] = obj.value;
      this.isSearch = true;
      this.getData(this.yearBo);
    },
    checkColumn(obj) {
      this.searchChecked = [];
      this.isSearch = true;
      if (obj.type === 'clear') {
        this.getData(this.yearBo);
      } else {
        this.searchChecked[obj.index] = obj.value;
        this.getData(this.yearBo);
      }
    },
    sortBy(obj) {
      this.isSearch = true;
      this.sortColumn[0] = obj.fieldName;
      this.sortColumn[1] = obj.value;
      this.getData(this.yearBo);
    },
    getParam(obj) {
      this.divisionFil = obj.divId;
      this.houseFil = obj.houseId[0] === null ? '' : obj.houseId;
      this.deptFil = obj.deptId;
      this.boFil = obj.boId;
      this.yearBo = obj.year;
      if (obj.type === 'set') {
        this.getData(obj.year);
      } else {
        this.downloadFile();
      }
    },
    searchPOAll() {
      this.isSearch = true;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.getData(this.yearBo);
      }, 900);
    },
    completePO(item) {
      let id = item.id;
      let text = item.is_completed ? 'uncomplete' : 'complete';
      let endpoint = item.is_completed
        ? 'purchasingOrder/uncompletePO'
        : 'purchasingOrder/completePO';
      Swal.fire({
        title: '',
        text: `Are you sure want to ${text} this Purchasing Order?`,
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then(result => {
        if (result.value) {
          this.progressDialogLoading = true;
          return this.$store
            .dispatch(endpoint, { id })
            .then(data => {
              this.progressDialogLoading = false;
              this.loading = false;
              if (data.code === 200) {
                Swal.fire({
                  title: 'Success!',
                  text: `${data.message.text_en}`,
                  type: 'success',
                  showCancelButton: false,
                  confirmButtonText: 'OK'
                }).then(resultData => {
                  if (resultData.value) {
                    this.getData(this.yearBo);
                  }
                });
              } else {
                Swal.fire(
                  'Failed!',
                  data.response.data.message.text_en,
                  'error'
                );
              }
            })
            .catch(err => {
              this.progressDialogLoading = false;
              this.loading = false;
              Swal.fire('Failed!', err.response.data.message.text_en, 'error');
            });
        }
      });
    },
    totalAmountFor(key) {
      let amountFor = this.items.reduce((total, item) => {
        const value = +(item[key] || 0);
        total += value;
        return total;
      }, 0);
      if (Number(amountFor) === 0) {
        return '-';
      } else {
        return this.idr(Math.round(amountFor));
      }
    },
    getData(year) {
      this.progressDialogLoading = true;
      this.loading = true;
      let date = new Date();
      this.showYear = moment(year).format('YYYY');
      if (!year) {
        year = moment(date).format('YYYY');
      } else {
        year = moment(year).format('YYYY');
      }
      let { page, itemsPerPage } = this.options;
      if (this.isSearch) {
        page = 1;
      }
      const search = {
        io_number: this.search,
        po_number: this.search
      };
      const sort = {
        field: this.sortColumn[0],
        sort: this.sortColumn[1]
      };
      const searchFieldColumn = {
        io_number: this.searchColumn[0],
        io_desc: this.searchColumn[1],
        budget_owner: this.searchColumn[2],
        po_number: this.searchColumn[3],
        po_date: this.searchColumn[4],
        delivery_date: this.searchColumn[5],
        vendor_name: this.searchColumn[6],
        po_item: this.searchColumn[7],
        release_desc: this.searchColumn[8],
        po_release_status: this.searchColumn[9],
        is_completed: this.searchColumn[10],
        currency: this.searchColumn[11],
        exchange_rate: this.searchColumn[12],
        amount: this.searchColumn[13],
        amount_idr: this.searchColumn[14],
        amount_complete: this.searchColumn[15],
        amount_local_currency: this.searchColumn[16],
        gr: this.searchColumn[17],
        ir: this.searchColumn[18],
        remaining_po: this.searchColumn[19]
      };
      const filters = {
        io_number: this.searchChecked[0],
        io_desc: this.searchChecked[1],
        budget_owner: this.searchChecked[2],
        po_number: this.searchChecked[3],
        po_date: this.searchChecked[4],
        delivery_date: this.searchChecked[5],
        vendor_name: this.searchChecked[6],
        po_item: this.searchChecked[7],
        release_desc: this.searchChecked[8],
        po_release_status: this.searchChecked[9],
        is_completed: this.searchChecked[10],
        currency: this.searchChecked[11],
        exchange_rate: this.searchChecked[12],
        amount: this.searchChecked[13],
        amount_idr: this.searchChecked[14],
        amount_complete: this.searchChecked[15],
        amount_local_currency: this.searchChecked[16],
        gr: this.searchChecked[17],
        ir: this.searchChecked[18],
        remaining_po: this.searchChecked[19]
      };
      return this.$store
        .dispatch('purchasingOrder/getMonitoring', {
          year,
          page,
          search,
          limit: itemsPerPage,
          filter: this.paramFiltered,
          searchFieldColumn,
          filters,
          sorting: this.sortColumn.length > 0 ? sort : ''
        })
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          this.isSearch = false;
          if (data.code === 200) {
            this.items = data.data.result.map(item => {
              return {
                ...item,
                amount_complete: item.is_completed ? item.gr : 0
              };
            });
            this.amountTotal = data.data;
            this.totalItems = Number(data.data.total_data);
            page = data.data.pagination.current_page;
            itemsPerPage = data.data.pagination.per_page;
            this.options = { page, itemsPerPage };
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          this.progressDialogLoading = false;
          this.loading = false;
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
        });
    },
    downloadFile() {
      let filters = '';
      if (this.paramFiltered.length > 0) {
        for (var i = 0; i < this.paramFiltered.length; i++) {
          filters +=
            `&filter[]={"divisionIds":[${this.paramFiltered[i].divisionIds}],` +
            `"houseIds":[${this.paramFiltered[i].houseIds}],` +
            `"groupIds":[${this.paramFiltered[i].groupIds}],` +
            `"budgetOwnerIds":[${this.paramFiltered[i].budgetOwnerIds}]}`;
        }
      }
      let year = moment(this.yearBo).format('YYYY');
      let profile_id = localStorage.getItem('profile_id');
      window.open(
        this.baseUrl +
          '/v1/purchasing-orders/download/report?profile_id=' +
          profile_id +
          '&year=' +
          year +
          filters +
          '&token=' +
          localStorage.getItem('app_token'),
        '_blank'
      );
    }
  }
};
</script>
<style>
.filterby-info .v-expansion-panel-header__icon {
  margin-left: 0px !important;
}
.drawer-menu--scroll {
  max-height: 300px;
  overflow: auto;
}
.drawer-menu--scrollEdit {
  max-height: 450px;
  overflow: auto;
}
.select-column-scroll {
  max-height: 250px;
  overflow: auto;
}
v-dialog {
  overflow-y: hidden !important;
}
.hr-line {
  margin-bottom: 10px;
  margin-top: 20px;
  border: 1px solid rgb(151, 151, 151);
}

.table-po table {
  display: block;
}
.table-po table th,
.table-po table td {
  white-space: nowrap !important;
  height: 30px !important;
}
/* width */
.table-po ::-webkit-scrollbar {
  height: 8px;
}
/* Track */
.table-po ::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
.table-po ::-webkit-scrollbar-thumb {
  background: #d5d5d5;
  border-radius: 20px;
}

/* Handle on hover */
.table-po ::-webkit-scrollbar-thumb:hover {
  background: #bbb;
}
.table-po .theme--light.v-data-table thead tr th {
  font-size: 14px !important;
  font-style: normal !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  line-height: 17px !important;
  letter-spacing: -0.02em !important;
  text-align: center !important;
  border-right: 1px solid #0000001f;
  height: 37px !important;
  color: #fff !important;
  background: #28a0f6 !important;
}
.table-po .theme--light.v-data-table tbody td {
  height: 30px !important;
  border-right: 0.5px solid rgba(0, 0, 0, 0.12);
  border-left: 0.5px solid rgba(0, 0, 0, 0.12);
}
</style>
